/**
 * العربية — Arabic (MSA) translations for the Farmsons marketing site.
 * `data` overrides content from src/lib/data.js, keyed by slug / name / index.
 * Cultivar, rootstock and series names stay in Latin script — they are the
 * identifiers used in international horticultural trade.
 */
export default {
  common: {
    quote: "اطلب عرض سعر",
    downloadProfile: "حمّل الملف التعريفي للشركة",
  },
  nav: {
    ventures: "أعمالنا",
    fruit: "تجارة الفاكهة",
    rootstock: "استيراد وتوزيع أصول التفاح",
    mango: "تصدير المانجو",
    story: "قصتنا",
    sourcing: "مصادر التوريد",
    partners: "شركاؤنا",
    quality: "الجودة",
    insights: "رؤى ومقالات",
    contact: "اتصل بنا",
    language: "اللغة",
  },
  hero: {
    lines: ["من البستان", "إلى التصدير —", "نتاجر بمستقبل", "المنتجات الزراعية"],
    sub: "تربط فارمسونز المزارعين في هيماتشال وكشمير وأحزمة المانجو الهندية مباشرةً بالمشترين الدوليين — جامعةً التنظيم ومعايير الجودة وعلاقات حقيقية مع المزارعين في شركة تجارية حديثة واحدة.",
    partner: "شارِكنا",
  },
  marquee: {
    items: ["تفاح", "مانجو", "أصول التفاح", "استيراد عالمي", "بمعايير التصدير", "هيماتشال", "كشمير", "مالدا"],
  },
  ventures: {
    overline: "ماذا نفعل",
    heading: "ثلاثة قطاعات. انضباط تشغيلي واحد.",
    para: "نموذج قابل للتكرار صُمم لإضافة قطاعات جديدة دون إعادة تصميم — من التجارة اليوم إلى الاستيراد والتصدير تالياً.",
    explore: "استكشف",
  },
  cine: { l1: "من البستان", l2pre: "إلى", l2accent: "التصدير." },
  partnersGrid: {
    overline: "شركاؤنا",
    heading: "موثوقون من شركاء عبر سلسلة التوريد.",
    visit: "زيارة الموقع",
  },
  home: {
    storyOverline: "قصتنا",
    storyHeading: "جذور متوارثة تلتقي بانضباط تشغيلي حديث.",
    storyLink: "اقرأ قصتنا كاملة وتعرّف على المؤسس",
    ctaHeading: "لنبنِ شراكة تجارية معاً.",
  },
  about: {
    overline: "قصتنا",
    title: "جذور متوارثة تلتقي بانضباط تشغيلي حديث.",
    lede: "دار تجارية متجذرة في كولكاتا تدخل فصلها التالي — جامعةً التنظيم ومعايير الجودة والعلاقات المباشرة مع المزارعين في شركة واحدة.",
    founderOverline: "المؤسس",
    founderHeading: "خلفية مختلفة، في تجارة تقليدية.",
    exploreLink: "استكشف ما نفعله — تجارة الفاكهة وأصول التفاح وتصدير المانجو",
  },
  vertical: {
    overline: "ماذا نفعل",
    ctaHeading: "مهتم بقطاع {venture}؟ لنتحدث.",
    exploreOthers: "استكشف الأعمال الأخرى:",
    sourcingLink: "مصادر التوريد والمناطق",
    appleOverline: "أصناف التفاح",
    appleTitle: "تفاح من هيماتشال براديش وكشمير",
    appleIntro: "متجذرون في الأصناف الحقيقية التي نورّدها — من رويال ديليشس المميز لهيماتشال إلى جراني سميث الأخضر الحامض وتفاح كينور عالي الارتفاع.",
    mangoOverline: "أصناف المانجو",
    mangoTitle: "مانجو من جنوب الهند وشرقها",
    mangoIntro: "من ألفونسو الفاخر وكيسار وبنغانبلي المسجلين بمؤشر جغرافي إلى هيمساغر ولانجرا العطريين من حزام مالدا في البنغال.",
  },
  sourcing: {
    overline: "مصادر التوريد والمناطق",
    title: "من منحدرات الهيمالايا إلى دلتا الغانج — وثمانية مصادر استيراد.",
    lede: "كل منطقة نورّد منها اختيرت لسبب. مرّر فوق أي نقطة على الخريطة لاستكشاف شبكتنا العالمية من علاقات المزارعين ومصادر التجارة.",
    legendHQ: "المقر الرئيسي — كولكاتا",
    legendOrigins: "مصادر التوريد والتجارة — مرّر فوق نقطة لاستكشافها.",
    importOverline: "مصادر استيراد التفاح",
    tradeLink: "اطلع على كيفية تجارتنا واستيرادنا للفاكهة",
  },
  map: { title: "شبكة التوريد العالمية" },
  partnersPage: {
    overline: "شركاؤنا",
    title: "موثوقون من شركاء عبر سلسلة التوريد.",
    lede: "من مدخلات البستان إلى التوزيع ولوجستيات التصدير، تتعاون فارمسونز مع أسماء راسخة للتسليم الموثوق في كل مرحلة.",
  },
  qualityPage: {
    overline: "الجودة والشهادات",
    title: "معايير مبنية لثقة عابرة للحدود.",
    lede: "يقيّم المشترون الدوليون الشريك التجاري على أساس الاتساق. أربع ركائز تدعم كل ما تشحنه فارمسونز — من مزارع معروف بالاسم إلى ميناء بعيد.",
  },
  qualityGrid: {
    overline: "لماذا يهم هذا",
    para: "يقيّم المشترون الدوليون الشريك التجاري على أساس الاتساق. صُمم إطار الجودة لدينا لتلبية مواصفات الاستيراد والامتثال وإمكانية التتبع منذ اليوم الأول.",
    badge: "لوجستيات جاهزة للتصدير",
  },
  insights: {
    overline: "رؤى ومقالات",
    title: "ملاحظات من البستان إلى الميناء.",
    lede: "منظور عملي حول تجارة الفاكهة في الهند — توقعات المواسم وعلم الزراعة وخبرة التصدير للمشترين والمزارعين.",
    read: "اقرأ المقال",
  },
  article: {
    back: "كل المقالات",
    cta: "تتطلع للتوريد أو الشراكة مع فارمسونز؟",
  },
  contact: {
    overline: "اتصل بنا / اطلب عرض سعر",
    title: "لنبنِ شراكة تجارية معاً.",
    para: "سواء كنت مستورداً دولياً أو مزارع بساتين أو شريك توريد — أخبرنا بما تحتاجه وسيرد فريقنا مباشرة.",
    address: "كولكاتا، غرب البنغال، الهند",
    waPreface: "تفضل محادثة سريعة؟ تواصل معنا عبر واتساب.",
    profileTitle: "الملف التعريفي للشركة",
    profileDesc: "نبذة من صفحة واحدة عن فارمسونز — قطاعاتنا ومناطق توريدنا ومعايير جودتنا.",
  },
  form: {
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    company: "الشركة",
    country: "الدولة",
    interest: "مجال الاهتمام بالمنتجات",
    message: "الرسالة",
    namePh: "اسمك",
    emailPh: "you@company.com",
    companyPh: "اسم الشركة",
    countryPh: "الدولة",
    interestPrompt: "اختر مجال اهتمام",
    messagePh: "أخبرنا عن متطلباتك والكميات والجداول الزمنية.",
    submit: "أرسل الاستفسار",
    sending: "جارٍ الإرسال...",
    incomplete: "يرجى إكمال جميع الحقول.",
    error: "حدث خطأ ما. يرجى المحاولة مجدداً.",
    tooMany: "طلبات كثيرة جداً. يرجى الانتظار قليلاً ثم المحاولة مجدداً.",
    successTitle: "تم استلام الاستفسار",
    successBody: "شكراً لك. سيتواصل معك أحد أعضاء فريق فارمسونز قريباً.",
    successAgain: "أرسل استفساراً آخر",
    successToast: "تم إرسال الاستفسار — سيتواصل معك فريقنا.",
  },
  wa: {
    chat: "تحدث عبر واتساب",
    aria: "تحدث مع فارمسونز عبر واتساب",
    message: "مرحباً فارمسونز، أود مناقشة استفسار حول تجارة المنتجات الزراعية.",
  },
  rootstockGuide: {
    overline: "دليل أصناف أصول التفاح",
    title: "اختر الأصل المناسب لبستانك.",
    intro: "يحدد اختيار الأصل حجم الشجرة وسرعة إثمار البستان ومقاومته للأمراض وملاءمته للتربة والمناخ المحليين. تساعد فارمسونز مزارعي هيماتشال وكشمير على مطابقة الأصل المناسب للموقع المناسب — لا مجرد توريده. رشّح حسب السلسلة أو فئة القوة أدناه.",
    series: "السلسلة",
    vigor: "القوة",
    all: "الكل",
    bestFit: "الأنسب لـ",
    noMatch: "لا توجد أصول تطابق هذه التوليفة.",
  },
  unsub: {
    title: "إلغاء الاشتراك",
    processing: "جارٍ معالجة طلبك…",
    success: "تم إلغاء الاشتراك",
    successBody: "تمت إزالتك من نشرتنا البريدية. نأسف لرؤيتك تغادر.",
    invalid: "رابط غير صالح",
    invalidBody: "رابط إلغاء الاشتراك هذا غير صالح أو تم استخدامه مسبقاً.",
    home: "العودة إلى الرئيسية",
  },
  footer: {
    blurb: "من البستان إلى التصدير — شركة مسجلة لتجارة المنتجات الزراعية تبني بنية تحتية حديثة بين المزارعين والمشترين الدوليين. تأسست عام 1985، كولكاتا.",
    explore: "استكشف",
    office: "المكتب",
    ourStory: "قصتنا",
    city: "كولكاتا، غرب البنغال",
    country: "الهند",
    rights: "جميع الحقوق محفوظة.",
    tagline: "نتاجر بمستقبل المنتجات الزراعية.",
    newsTitle: "نشرة فارمسونز البريدية",
    newsDesc: "ملاحظات موسمية عن تجارة الفاكهة في الهند، مباشرة إلى بريدك.",
    newsPlaceholder: "بريدك الإلكتروني",
    newsButton: "اشترك",
    newsSuccess: "تم الاشتراك — أهلاً بك في نشرة فارمسونز.",
    newsError: "تعذر الاشتراك. يرجى المحاولة مجدداً.",
  },
  data: {
    ventures: {
      "fruit-trading": {
        status: "نشط الآن",
        title: "تجارة الفاكهة",
        tagline: "توريد التفاح والمانجو، واستيراد منظم، وتوزيع على أساس العمولة — انطلاقاً من كولكاتا.",
        tags: ["تفاح", "مانجو", "استيراد", "توزيع"],
        intro: "تجارة الفاكهة هي القطاع النشط المدرّ للإيرادات في فارمسونز. نشتري مباشرة من المزارعين، ونطبق ضبط جودة بمعايير التصدير، ونوصل الفاكهة إلى المشترين المحليين والدوليين عبر سلسلة توريد شفافة تقوم على العلاقات.",
        sections: [
          { heading: "توريد التفاح المحلي", body: "نورّد التفاح مباشرة من بساتين هيماتشال براديش (شيملا، كينور، كولو) وكشمير (شوبيان، سوبور). الشراء من بوابة المزرعة — لا عبر أسواق مجهولة — يعني أسعاراً أفضل للمزارعين وتتبعاً كاملاً للمشترين." },
          { heading: "توريد المانجو عبر جنوب الهند وشرقها", body: "خلال الموسم نشتري المانجو من حزام مالدا ومورشيدآباد في غرب البنغال بدلتا الغانج، ومن بساتين راسخة في أندرا براديش وكارناتاكا، مطابقين الصنف والدرجة لمتطلبات كل مشترٍ." },
          { heading: "استيراد تفاح منظم", body: "تشارك فارمسونز في تجارة استيراد التفاح إلى الهند من ثماني دول منشأ — تركيا وإيران وإيطاليا وبولندا وتشيلي وجنوب أفريقيا ونيوزيلندا والولايات المتحدة — مديرةً التوريد والتوثيق وسلسلة التبريد إلى السوق الهندية." },
          { heading: "توزيع على أساس العمولة", body: "من خلال شراكات توزيع على أساس العمولة تتمركز في كولكاتا، نربط الشحنات بشبكة موثوقة من تجار الجملة والتجزئة، مانحين الموردين طلباً ثابتاً ووصولاً واسعاً إلى السوق." },
        ],
        highlights: {
          title: "كيف تتحرك الشحنة",
          items: [
            { title: "01 · التوريد", desc: "شراء من بوابة المزرعة مرتبط بعلاقات مع مزارعين معروفين بالاسم." },
            { title: "02 · الفرز", desc: "فرز مُعايَر للحجم ونسبة السكر (بريكس) والعيوب وفق المواصفات." },
            { title: "03 · النقل", desc: "مناولة مُتحكم بحرارتها إلى السوق أو الميناء." },
            { title: "04 · التسوية", desc: "تسوية شفافة وفي وقتها للمزارعين والمشترين." },
          ],
        },
      },
      rootstock: {
        status: "يُطلق قريباً",
        title: "استيراد وتوزيع أصول التفاح",
        tagline: "أصول تفاح معتمدة — M9 وMM106 وM111 — لبساتين عالية الكثافة في هيماتشال وكشمير.",
        intro: "يُرسخ قطاع استيراد وتوزيع أصول التفاح مكانة فارمسونز كشريك موثوق للمدخلات الزراعية. نستورد أصول تفاح مستنسخة معتمدة ونوزعها على المزارعين الذين يحدّثون بساتينهم — مطابقين الأصل المناسب للموقع المناسب.",
        sections: [
          { heading: "ما هو أصل الشجرة — ولماذا يهم", body: "شجرة التفاح نباتان مندمجان: صنف مثمر (الطعم) مطعوم على نظام جذري (الأصل). يتحكم الأصل في حجم الشجرة وسرعة إثمارها ومدى تحملها للتربة والأمراض. اختيار الأصل الصحيح هو أهم قرار منفرد عند زراعة بستان حديث." },
          { heading: "M9 — كثافة عالية وإثمار مبكر", body: "أصل مُقزِّم يحافظ على صغر حجم الأشجار، مما يسمح بآلاف الأشجار لكل هكتار على شبكة دعامات. تثمر البساتين أبكر وتصبح أسهل في التقليم والحصاد — وهو أساس الزراعة عالية الكثافة." },
          { heading: "MM106 — خيار متوازن موثوق", body: "أصل شبه مقزّم يوفر توازناً قوياً بين القوة والتثبيت والمحصول. مناسب تماماً لمجموعة واسعة من المواقع التي لم تكتمل فيها بعد بنية الزراعة عالية الكثافة." },
          { heading: "M111 — قوة للمواقع الأصعب", body: "أصل قوي ومتين يتحمل الجفاف والتربة المتغيرة، ويمنح أشجاراً راسخة التثبيت في الأراضي الهامشية أو أراضي إعادة الزراعة حيث تعجز الأنواع المقزّمة." },
        ],
        highlights: {
          title: "لماذا يشاركنا المزارعون",
          items: [
            { title: "مخزون معتمد", desc: "مادة مستنسخة قابلة للتتبع ومفحوصة ضد الأمراض." },
            { title: "مشورة دقيقة", desc: "أصل مطابق للموقع والصنف والأهداف." },
            { title: "جاهزية عالية الكثافة", desc: "دعم لأنظمة البساتين الحديثة ذات الدعامات." },
            { title: "إمداد موثوق", desc: "استيراد منظم حتى لا تُفوَّت مواسم الزراعة." },
          ],
        },
      },
      "mango-export": {
        status: "يُطلق قريباً",
        title: "تصدير المانجو",
        tagline: "ألفونسو وكيسار وبنغانبلي وتوتابوري — بمعايير التصدير، إلى الإمارات والمملكة المتحدة والولايات المتحدة وكندا.",
        intro: "يمدّ تصدير المانجو قوة فارمسونز في التوريد إلى الأسواق الدولية. ومدعومين بتوريد قابل للتتبع ومعايير بدرجة التصدير، نبني مسارات توصل أصناف المانجو الهندية الفاخرة إلى المشترين المميزين في الخارج.",
        sections: [
          { heading: "ألفونسو — الرائد", body: "بفضل لبّه الزعفراني اللون وعطره ونكهته الغنية، يُعد ألفونسو أشهر مانجو في الهند وحجر الأساس للطلب الفاخر على التصدير في الخليج والمملكة المتحدة وأمريكا الشمالية." },
          { heading: "كيسار — عطري ونابض", body: "معروف بلبّه البرتقالي الزاهي وعطره المميز، يتحمل كيسار الشحن جيداً ويحظى بشعبية وفيّة في أسواق الجاليات الجنوب آسيوية." },
          { heading: "بنغانبلي وتوتابوري — حجم من جنوب الهند", body: "يقدم بنغانبلي فاكهة كبيرة عديمة الألياف وحلوة بعمر تخزين طويل، بينما يضيف توتابوري حجماً حمضياً مناسباً للتصنيع — موسعين معاً سلة التصدير إلى ما بعد موسم واحد." },
        ],
        highlights: {
          title: "الأسواق المستهدفة",
          items: [
            { title: "الإمارات", desc: "طلب خليجي راسخ على المانجو الهندي الفاخر." },
            { title: "المملكة المتحدة", desc: "طلب قوي من الجاليات وتجارة التجزئة المتخصصة." },
            { title: "الولايات المتحدة", desc: "سوق فاخرة متنامية في إطار بروتوكولات التصدير." },
            { title: "كندا", desc: "شهية متوسعة للفاكهة المفرزة القابلة للتتبع." },
          ],
        },
      },
    },
    pillars: [
      { title: "إرث منذ عام 1985", body: "تحمل فارمسونز إرثاً عائلياً في تجارة المنتجات الزراعية يمتد لنحو أربعة عقود — متجذراً في علاقات حقيقية مع المزارعين عبر هيماتشال براديش وكشمير وأحزمة المانجو في جنوب الهند وشرقها." },
      { title: "الفجوة التي نسدّها", body: "اعتمدت تجارة المنتجات الزراعية في الهند على علاقات غير رسمية وأسواق محلية، مع بنية تحتية حديثة ضئيلة تربط المزارعين بالمشترين الدوليين. تبني فارمسونز هذه الطبقة — من تجارة الفاكهة إلى توزيع أصول التفاح وتصدير المانجو." },
      { title: "جذور تلتقي بالانضباط", body: "التنظيم ومعايير الجودة والعلاقات المباشرة مع المزارعين، مجتمعةً في شركة واحدة. جذور متوارثة تلتقي بانضباط تشغيلي حديث — دار تجارية من كولكاتا تدخل فصلها التالي." },
    ],
    founder: {
      name: "زاهد شاميم",
      role: "المؤسس",
      tags: ["جامعة جادافبور", "ماجستير إدارة الأعمال — UCLA Anderson", "سابقاً في Visa", "سابقاً في PropTech"],
      paras: [
        "تقود فارمسونزَ إلى مرحلتها التالية مؤسسُها زاهد شاميم — خريج هندسة علوم الحاسوب من جامعة جادافبور وحاصل على ماجستير إدارة الأعمال من UCLA Anderson، مع خبرة سابقة في قيادة المنتجات والتكنولوجيا في Visa وشركة PropTech.",
        "يقود اليوم الاستراتيجية والعمليات والمنتج واستراتيجية دخول السوق في فارمسونز — مطبقاً الانضباط التجاري العالمي على شركة تجارة زراعية مقرها كولكاتا. إنها قصة جذور متوارثة تلتقي بانضباط تشغيلي حديث: تعليم متجذر في كولكاتا، ومسيرة مهنية عالمية، وعودة لقيادة أعمال العائلة إلى فصلها التالي.",
        "رؤيته هي تحويل عمل تجاري قائم على العلاقات إلى بنية تحتية حديثة واحترافية — حيث يكون المزارعون شركاء معروفين بالاسم، وتُقاس الجودة وفق المواصفات الدولية، ويمكن للمشترين في أي مكان في العالم التعامل مع شركة واحدة خاضعة للمساءلة. التكنولوجيا والشفافية وإمكانية التتبع هي الخيط الناظم من تجارة الفاكهة اليوم إلى توزيع أصول التفاح وتصدير المانجو لاحقاً.",
      ],
    },
    regions: [
      { name: "هيماتشال براديش", type: "حزام التفاح", note: "بساتين عالية الارتفاع عبر شيملا وكينور وكولو وماندي." },
      { name: "كشمير", type: "حزام التفاح", note: "تفاح فاخر من الوادي، من شوبيان وسوبور." },
      { name: "مالدا ومورشيدآباد", type: "منطقة مانجو — غرب البنغال", note: "حزام دلتا الغانج المشهور بأصناف المانجو العطرية." },
      { name: "أندرا وكارناتاكا", type: "منطقة مانجو — جنوب الهند", note: "بنغانبلي وتوتابوري من بساتين جنوبية راسخة." },
    ],
    importOrigins: ["تركيا", "إيران", "إيطاليا", "بولندا", "تشيلي", "جنوب أفريقيا", "نيوزيلندا", "الولايات المتحدة"],
    mapLabels: ["كولكاتا (المقر)", "هيماتشال وكشمير", "تركيا", "إيران", "إيطاليا", "بولندا", "الولايات المتحدة", "تشيلي", "جنوب أفريقيا", "نيوزيلندا"],
    quality: [
      { title: "توريد قابل للتتبع", desc: "ترتبط كل شحنة بعلاقة مع مزارع معروف بالاسم ومنطقة منشأ محددة — وليس بأسواق مجهولة أبداً. يتيح هذا التتبع للمشترين ضمان المنشأ ولنا ضمان الجودة." },
      { title: "فرز بمعايير التصدير", desc: "تُفرز الفاكهة وفق مواصفات المشترين الدوليين — حجم مُعايَر وقياس نسبة السكر (بريكس) وفحص العيوب — فما يُطلب هو بالضبط ما يصل، شحنة بعد شحنة." },
      { title: "سلامة سلسلة التبريد", desc: "مناولة مُتحكم بحرارتها من محطة التعبئة إلى الميناء تحمي الصلابة والنكهة والعمر التخزيني، وتقلل التلف وتمنح المشترين البعيدين حالة موثوقة ومتسقة عند الوصول." },
      { title: "جاهزية الامتثال", desc: "صُممت عمليات التوثيق والصحة النباتية للتجارة عبر الحدود منذ اليوم الأول، فتُخليص الشحنات بسلاسة ولا يواجه المشترون مفاجآت على الحدود." },
    ],
    interests: ["تجارة التفاح", "تصدير المانجو", "استيراد التفاح", "توريد أصول التفاح", "شراكة توزيع", "أخرى"],
    vigor: { Dwarfing: "مُقزِّم", "Semi-dwarf": "شبه مقزّم", "Semi-vigorous": "شبه قوي", Vigorous: "قوي" },
    varieties: {
      "Royal Delicious": { tag: "هيماتشال · ذروة سبتمبر", desc: "تفاح هيماتشال المميز — أحمر غامق ومقرمش وحلو. يُورَّد أساساً من كولو وشيملا وكينور وماندي." },
      "Red Delicious": { tag: "هيماتشال · سبتمبر", desc: "من أقدم الأصناف التجارية — نكهة معتدلة وقشرة حمراء غامقة بخطوط خضراء دقيقة." },
      "Golden Delicious": { tag: "جامو وكشمير · أكتوبر", desc: "قشرة صفراء مخضرّة بحلاوة عسلية معتدلة. شائع عبر جامو وكشمير." },
      "Royal Gala": { tag: "كشمير · أغسطس", desc: "أحمر فاتح إلى وردي، حلو ومقرمش — مفضل مبكر الموسم يُورَّد من كشمير." },
      Fuji: { tag: "مرتفعات هيماتشال · أكتوبر", desc: "كبير وصلب وشديد الحلاوة بعمر تخزين طويل. يُزرع في بساتين مختارة عالية الارتفاع في هيماتشال." },
      "Granny Smith": { tag: "مناطق مختارة · أكتوبر", desc: "أخضر زاهٍ ومنعش الحموضة — تفاحة صلبة متعددة الاستخدامات تُزرع في مناطق مختارة." },
      "Kinnaur Apple": { tag: "كينور · نحو 9000 قدم", desc: "يُزرع على ارتفاع عالٍ حوالي 9000 قدم — أحمر داكن عميق يُقدَّر لقرمشته الاستثنائية." },
      "Scarlet Spur": { tag: "هيماتشال · سبتمبر", desc: "انتقاء من شتلات ريد ديليشس بقشرة قرمزية زاهية ولب أبيض حلو." },
      Alphonso: { tag: "فاخر · أبريل–يونيو", desc: "أشهر مانجو في الهند — لب زعفراني وعطر غني ونكهة تحدد الطلب الفاخر على التصدير." },
      Kesar: { tag: "مؤشر جغرافي · غوجارات", desc: "مسجل بمؤشر جغرافي من منطقة جوناغاد / جير سومناث في غوجارات — لب برتقالي زاهٍ وعطر مميز." },
      Banganapalli: { tag: "مؤشر جغرافي · أندرا", desc: "مسجل بمؤشر جغرافي من أندرا براديش — فاكهة كبيرة عديمة الألياف وحلوة بعمر تخزين طويل." },
      Totapuri: { tag: "كارناتاكا وأندرا", desc: "حمضي وصلب بشكل منقار مميز — يُزرع على نطاق واسع عبر كارناتاكا وأندرا براديش." },
      Himsagar: { tag: "مالدا · غرب البنغال", desc: "صنف عطري عديم الألياف من حزام مالدا / مورشيدآباد في غرب البنغال، غني وكريمي." },
      Langra: { tag: "مالدا · غرب البنغال", desc: "صنف أخضر القشرة عطري متأخر النضج من حزام مالدا / مورشيدآباد." },
    },
    rootstocks: {
      M9: { traits: "نحو 30–35٪ من حجم الشجرة القياسية، إثمار مبكر، محصول عالٍ جداً. يتطلب دعامات.", fit: "زراعة عالية الكثافة على تربة مروية خصبة." },
      M26: { traits: "نحو 40–50٪ من الحجم القياسي، مبكر ومنتج مع مقاومة جيدة للأمراض.", fit: "بساتين بكثافة متوسطة إلى عالية." },
      M7: { traits: "منتج باعتدال بمجرد استقراره.", fit: "زراعات بكثافة متوسطة إلى منخفضة." },
      MM106: { traits: "قوي وقابل للتكيف على نطاق واسع، تثبيت جيد، مقاوم لأمراض الجذور.", fit: "التخطيطات التقليدية في هيماتشال وكشمير بكثافة متوسطة (650–800 شجرة/هكتار)." },
      MM111: { traits: "شديد التحمل للجفاف، جذور منتشرة واسعة، مقاوم لمنّ التفاح الصوفي؛ متحمل للفحة النارية وتعفن التاج والجذور.", fit: "التضاريس الجبلية المعرضة للجفاف." },
      "EMLA-9": { traits: "انتقاء M9 مفحوص فيروسياً لأداء موثوق.", fit: "زراعة عالية الكثافة على تربة عميقة مروية." },
      "EMLA-111": { traits: "انتقاء MM111 مفحوص فيروسياً.", fit: "مناطق الزراعة المعرضة للجفاف." },
      "EMLA-106": { traits: "انتقاء MM106 مفحوص فيروسياً.", fit: "تربة منحدرة أقل طينية." },
      "EMLA-7": { traits: "انتقاء M7 مفحوص فيروسياً.", fit: "الأراضي المنحدرة." },
      "B9 (Bud 9)": { traits: "حجم مشابه لـ M9 مع تحمل أقوى بكثير للبرودة.", fit: "مزارع هيماتشال وكشمير الأعلى ارتفاعاً." },
      B118: { traits: "شديد التحمل لبرد الشتاء، مبكر وعالي الإنتاج؛ مقاوم لتعفن التاج والجذور.", fit: "المواقع الباردة ذات التربة المتنوعة." },
      G11: { traits: "فئة حجم M9 مع مقاومة قوية للأمراض.", fit: "مواقع عالية الكثافة كثيرة الضغط المرضي." },
      G41: { traits: "مقاومة قوية لأمراض إعادة الزراعة واللفحة النارية ومنّ التفاح الصوفي.", fit: "أداء جيد عبر أنواع التربة المختلفة." },
      G935: { traits: "أكبر قليلاً من M26، مبكر جداً ومنتج بحجم ثمار ممتاز.", fit: "بساتين منتجة بكثافة متوسطة." },
      G214: { traits: "قوة متوسطة مع أداء قوي في المحصول والنمو.", fit: "مزارعون يريدون قوة أكبر من الخيارات المقزّمة." },
      G969: { traits: "قوة متوسطة مع أداء قوي في المحصول والنمو.", fit: "مزارعون يريدون قوة أكبر من الخيارات المقزّمة." },
    },
    articles: {
      "himachal-apple-season-outlook": {
        title: "توقعات موسم تفاح هيماتشال: ما يجب أن يعرفه المشترون",
        excerpt: "من جالا في أغسطس إلى فوجي في أكتوبر، يشكّل تقويم حصاد هيماتشال التوفر والأسعار والجودة على مدار الموسم.",
        readTime: "قراءة 5 دقائق",
        body: [
          { h: "موسم يتحرك مع الارتفاع", p: "يتكشف حصاد تفاح هيماتشال على موجات. يتصدر رويال جالا في أغسطس، وتبلغ مجموعة ديليشس (رويال وريد وسكارليت سبير) ذروتها خلال سبتمبر، وتختتم الأصناف الأصلب مثل فوجي وجراني سميث الموسم في أكتوبر. وتنضج مزارع كينور الأعلى ارتفاعاً لاحقاً مانحةً قرمشة استثنائية." },
          { h: "لماذا يهم التوقيت للمشترين", p: "معرفة التقويم تتيح للمشترين التخطيط للكميات والأسعار. يستحق جالا المبكر علاوات الطزاجة؛ وتوفر ذروة سبتمبر لمجموعة ديليشس أفضل توازن بين الحجم واللون؛ ويناسب فوجي المتأخر المشترين الذين يحتاجون عمراً تخزينياً أطول للأسواق البعيدة." },
          { h: "كيف تورّد فارمسونز", p: "نشتري من بوابة المزرعة عبر شيملا وكولو وكينور وماندي، ونربط كل دفعة بمزارع معروف بالاسم، ونفرز وفق مواصفات المشتري — فالفاكهة التي تُشحن هي بالضبط ما طُلب." },
        ],
      },
      "choosing-apple-rootstock-himachal-kashmir": {
        title: "اختيار أصل التفاح المناسب لهيماتشال وكشمير",
        excerpt: "يحدد الأصل حجم الشجرة وسرعة إثمار البستان ومدى صموده أمام التربة والمناخ المحليين. إليك كيفية الاختيار.",
        readTime: "قراءة 6 دقائق",
        body: [
          { h: "الأصل هو الأساس", p: "شجرة التفاح صنف مثمر مطعوم على أصل. يتحكم الأصل في القوة (حجم الشجرة) والبكور (سرعة الإثمار) ومقاومة الأمراض وتحمل التربة — القرار الأهم عند الزراعة." },
          { h: "مطابقة الأصل للموقع", p: "تناسب الأصول المقزّمة مثل M9 وB9 وG41 المزارع المروية عالية الكثافة؛ ويضيف B9 تحملاً للبرودة في الارتفاعات الأعلى. يتحمل MM111 القوي المنحدرات المعرضة للجفاف. ويبقى MM106 خياراً موثوقاً للكثافة المتوسطة عبر هيماتشال وكشمير." },
          { h: "شريك، لا مجرد مورد", p: "تساعد فارمسونز المزارعين على مطابقة الأصل مع التربة والصنف والأهداف — جالبةً مادة معتمدة ومفحوصة فيروسياً وإرشاداً زراعياً إلى البستان." },
        ],
      },
      "indian-mango-export-varieties": {
        title: "المانجو الذي تصدّره الهند: ألفونسو وكيسار وما بعدهما",
        excerpt: "دليل إلى الأصناف التي تقود طلب التصدير الفاخر للمانجو الهندي — والمناطق والمواسم وراءها.",
        readTime: "قراءة 4 دقائق",
        body: [
          { h: "الأصناف الرائدة", p: "يتصدر ألفونسو بالعطر والنكهة، ويجلب كيسار (مسجل بمؤشر جغرافي، غوجارات) لوناً نابضاً، ويقدم بنغانبلي (مسجل بمؤشر جغرافي، أندرا) فاكهة كبيرة عديمة الألياف طويلة العمر التخزيني. يضيف توتابوري حجماً حمضياً، بينما تحمل هيمساغر ولانجرا عطر حزام مالدا في البنغال." },
          { h: "الموسم والأسواق", p: "يمتد موسم الذروة من أبريل إلى يونيو. يتركز الطلب الفاخر في الإمارات والمملكة المتحدة والولايات المتحدة وكندا، حيث يُعد التوريد القابل للتتبع والمناولة بمعايير التصدير شرطين أساسيين." },
          { h: "مبني للتصدير", p: "تبني فارمسونز مسارات مدعومة بتوريد قابل للتتبع وفرز بمعايير التصدير حتى يصل المانجو الهندي الفاخر في حالة متسقة." },
        ],
      },
      "apple-import-origins-compared": {
        title: "مقارنة مصادر استيراد التفاح: ثماني دول، سلسلة توريد واحدة",
        excerpt: "تملأ تركيا وإيران وإيطاليا وبولندا وتشيلي وجنوب أفريقيا ونيوزيلندا والولايات المتحدة كلاً منها نافذة مختلفة في تقويم استيراد التفاح الهندي. إليك المقارنة.",
        readTime: "قراءة 6 دقائق",
        body: [
          { h: "لماذا تستورد الهند التفاح أصلاً", p: "فاكهة هيماتشال وكشمير المحلية موسمية. يملأ الاستيراد الفجوات — ممدداً التوفر على مدار العام، ومضيفاً أصنافاً وأحجاماً لا تغطيها البساتين المحلية، وملبياً الطلب الفاخر للتجزئة حين تنفد المخزونات المحلية." },
          { h: "مصادر نصف الكرة الشمالي", p: "تشحن تركيا وإيران وإيطاليا وبولندا خلال حصادها الخريفي وبعده مباشرة. تُعرف إيطاليا وبولندا بفرز متسق وبرامج تخزين مبرد تورد حتى العام الجديد؛ بينما تقدم تركيا وإيران كميات تنافسية قريبة إقليمياً." },
          { h: "مصادر نصف الكرة الجنوبي", p: "تحصد تشيلي وجنوب أفريقيا ونيوزيلندا على تقويم معاكس، فتصل حين تشيخ مخزونات الشمال — حافظةً تدفق فاكهة طازجة وصلبة خلال الأشهر الأشح في الهند. وتُقدَّر نيوزيلندا وتشيلي لجودة الأكل وبروتوكولات التصدير الموثوقة." },
          { h: "الولايات المتحدة", p: "يجلب التفاح الأمريكي (لا سيما ولاية واشنطن) أصنافاً فاخرة معروفة وفرزاً دقيقاً، خادماً الشريحة العليا من السوق." },
          { h: "كيف تديره فارمسونز", p: "ننسّق التوريد والتوثيق وسلسلة التبريد عبر المصادر الثمانية كلها إلى السوق الهندية — فيحصل المشترون على جودة متسقة وإمداد على مدار العام من شريك واحد خاضع للمساءلة." },
        ],
      },
    },
  },
};
